import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { normalizeRole } from '@/shared/utils/role'
import { getPlanByRef } from '../services/memberPlanService'
import { dismissAccountPlanOverrideNotice } from '../services/accessStateService'
import { useAccountAccessState } from '../hooks/useAccountAccessState'
import PlanExpiredNoticeModal from './PlanExpiredNoticeModal'

export default function PlanExpiredNoticeGate() {
  const { user, profile } = useAuth()
  const navigate = useNavigate()
  const { state, loading, reload } = useAccountAccessState()
  const [open, setOpen] = React.useState(false)
  const [planLabel, setPlanLabel] = React.useState<string | null>(null)

  const roleRaw = String(profile?.role || (user as any)?.user_metadata?.role || '').toLowerCase()
  const role = normalizeRole(roleRaw)
  const isMember = role === 'member'

  const shouldShow = !!(
    isMember &&
    !loading &&
    state?.overrideActive &&
    state?.noticePending &&
    String(state?.effectivePlanId || '').toLowerCase() === 'trial_7d'
  )

  React.useEffect(() => {
    setOpen(shouldShow)
  }, [shouldShow])

  React.useEffect(() => {
    let cancelled = false
    const ref = state?.originalPlanId || null
    if (!ref) {
      setPlanLabel(null)
      return
    }
    ;(async () => {
      try {
        const plan = await getPlanByRef(ref)
        if (!cancelled) setPlanLabel(plan?.name || ref)
      } catch {
        if (!cancelled) setPlanLabel(ref)
      }
    })()
    return () => { cancelled = true }
  }, [state?.originalPlanId])

  async function handleDismiss() {
    setOpen(false)
    try {
      await dismissAccountPlanOverrideNotice()
      await reload()
    } catch {}
  }

  async function handleRenew() {
    await handleDismiss()
    navigate('/my-plans')
  }

  if (!user?.id || !isMember) return null

  return (
    <PlanExpiredNoticeModal
      open={open}
      planLabel={planLabel}
      onDismiss={handleDismiss}
      onRenew={handleRenew}
    />
  )
}
